import React from 'react';
import PropTypes from 'prop-types';

function initialsFromAccountLabel(label) {
  if (!label || typeof label !== 'string') return '—';
  const parts = label.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase().slice(0, 2);
  }
  const word = parts[0] || '';
  if (!word) return '—';
  return word.slice(0, 2).toUpperCase();
}

function accountAvatarHue(label) {
  let h = 0;
  const s = String(label || '');
  for (let i = 0; i < s.length; i += 1) {
    h = s.charCodeAt(i) + ((h << 5) - h);
  }
  return Math.abs(h) % 360;
}

function SwitchAccountInitialsAvatar({ label }) {
  const initials = initialsFromAccountLabel(label);
  const hue = accountAvatarHue(label);
  return (
    <span
      className="el:inline-flex el:size-10 el:rounded-full el:overflow-hidden el:items-center el:justify-center el:text-white el:text-xs el:font-semibold el:uppercase el:shrink-0 el:leading-none"
      style={{ backgroundColor: `hsl(${hue} 48% 42%)` }}
      aria-hidden
    >
      {initials}
    </span>
  );
}

SwitchAccountInitialsAvatar.propTypes = {
  label: PropTypes.string.isRequired,
};

/** Current-company chip from Rails: `{ url, title, logo }` — not the same shape as `switch_account`. */
function isCompanyContextFooterRow(row) {
  if (!row || row.kind === 'switch_account') return false;
  return 'logo' in row;
}

function CompanyFooterLeadingIcon({ row }) {
  const label = row.title || 'Company';
  if (row.logo) {
    return (
      <span className="el:flex el:size-10 el:items-center el:justify-center el:shrink-0 el:overflow-hidden el:rounded-full el:bg-[#f3f3f3]">
        <img
          src={row.logo}
          alt=""
          className="el:h-full el:w-full el:rounded-full el:object-cover"
        />
      </span>
    );
  }
  return <SwitchAccountInitialsAvatar label={label} />;
}

CompanyFooterLeadingIcon.propTypes = {
  row: PropTypes.object.isRequired,
};

export { SwitchAccountInitialsAvatar, isCompanyContextFooterRow, CompanyFooterLeadingIcon };
